var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEvents = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.64 25.23q1.65 0 3.03-.795a5.86 5.86 0 0 0 2.175-2.16q.795-1.365.795-3.015 0-2.61-.72-5.04-.93 1.2-2.55 2.07-1.47.78-3.24 1.14-1.68.33-2.595 1.335T11.62 21.3q0 1.05.54 1.965t1.47 1.44 2.01.525m2.25-22.92q3.75 3.03 5.88 7.29 2.25 4.47 2.25 9.42 0 2.7-1.38 5.04a9.8 9.8 0 0 1-3.6 3.57q-2.31 1.35-5.04 1.35t-5.04-1.35a9.8 9.8 0 0 1-3.6-3.57 9.75 9.75 0 0 1-1.38-5.04q0-3.12 1.08-6.03 1.05-2.82 2.97-5.1v.45q0 1.29.585 2.355a4.41 4.41 0 0 0 3.915 2.295q1.26 0 2.235-.615t1.515-1.68.54-2.355q0-1.2-.24-2.76-.18-1.11-.45-2.31z"
})));
export default SvgEvents;